import React from 'react';
import { IMenuProps } from '../MenuProps';
import {MenuWrapper,MenuContainer,FooterContainer,PriceWrapper,TotalPrice,ButtonWithBackground,FooterDetail,FooterDetailText,FooterOpenBtn} from './MenuSimple-styled';

import {	
	isMobile,
	isLowHeight
} from './ui-helpers';

import {
	Materials,
	Stones,
	Engraving,
	Dimensions,
} from './Tabs/Tabs';

import { ArrowRightOutlined,RightOutlined,UpOutlined,DownOutlined } from '@ant-design/icons';

interface Props {
	menuType:'ifr'|'luxe'|'simple'|'simpleLuxe',
	menuProps:IMenuProps
};


interface State {	
	scrolling:boolean,
	isOpen:boolean
};


export default class MenuSimple extends React.Component<Props,State>{
    constructor(props:Props) {
        super(props);
        this.state = {
            scrolling: false,
			isOpen:false
        };
    };

    componentDidMount(){
        // console.log('currentMenuTab',this.props.currentMenuTab)
        // console.log('fingerSizeOptions',this.props.fingerSizeOptions)
        this.resize();
    }

	componentDidUpdate(prevProps, prevState): void {
		if(this.props.menuProps.configID != prevProps.configID){
			console.log('current props',this.props.menuProps.configID)
			console.log('prev props',prevProps.configID)
		}
		
		if(prevProps.checkoutIssues != this.props.menuProps.checkoutIssues){
			const mobile = isMobile();
			if(mobile && this.props.menuProps.checkoutIssues.includes('fingerSize')){
				this.setState({isOpen:true})
			}
		}		
	}

    resize = () => {
        if (!isMobile() && this.props.menuProps.currentMenuTab === -1) {
            this.props.menuProps.onMenuTabChange(0);
        } else {
            //We always want to call onMenuTabChange for its side effects
            this.props.menuProps.onMenuTabChange(this.props.menuProps.currentMenuTab);
        }
        // this.setState({ deviceInfo: vhCheck() });
    };

    render(){
        const { 
			currentMenuTab,
			checkoutModalVisible,
			checkoutURI,
			setCheckoutModalVisibility,
			shortLinkModalVisible,
			shortLink,
			setShortLinkModalVisibility,
			summaryModalVisible,
			setSummaryModalVisibility,

			setConfigId,
			
			ringSKU,
			ringScreenshot,
			configID,
			assetURI,

			checkoutIssues,
			price,

			fingerSize,
			fingerSizeFormatOptions,
			onFingerSizeChange,
			fingerSizeFormat,
			fingerSizeOptions,
			onFingerSizeFormatChange,
			ringWidth,
			ringWidthOptions,
			onRingWidthChange,
			ringThickness,
			ringThicknessOptions,
			onRingThicknessChange,
			autoRatio,
			onAutoRatioChange,

			metalGroups,
			onMetalGroupChange,
			currentMenuMetalGroup,
			onMenuMetalGroupChange,
			limitedMaterials,

			stoneCut,
			stoneCount,
			stoneCountOptions,
			onStoneCountChange,
			stoneSize,
			stoneSizeOptions,
			onStoneSizeChange,
			stoneGroups,
			onStoneGroupChange,
			currentMenuStoneGroup,
			onMenuStoneGroupChange,

			engravingText,
			onEngravingTextChange,
			engravingFont,
			engravingFontOptions,
			onEngravingFontChange
		} = this.props.menuProps;

        const { 			
			scrolling
		} = this.state;
        
        const mobile = isMobile();
		const lowHeight = isLowHeight();

        const tabs = [
			{
				title: 'Dimensions',
				icon: 'dimensions',
				content: <Dimensions
					fingerSize={fingerSize}
					fingerSizeOptions={fingerSizeOptions}
					onFingerSizeChange={(value)=>{
						onFingerSizeChange(value);
						setConfigId();
					}}

					fingerSizeFormat={fingerSizeFormat}
					fingerSizeFormatOptions={fingerSizeFormatOptions}
					onFingerSizeFormatChange={(value)=>{
						onFingerSizeFormatChange(value);
						setConfigId();
					}}

					ringWidth={ringWidth}
					ringWidthOptions={ringWidthOptions}
					onRingWidthChange={(value)=>{
						onRingWidthChange(value);
						setConfigId();
					}}

					ringThickness={ringThickness}
					ringThicknessOptions={ringThicknessOptions}
					onRingThicknessChange={(value)=>{
						onRingThicknessChange(value);
						setConfigId();
					}}

					autoRatio={autoRatio}
					onAutoRatioChange={(value)=>{
						onAutoRatioChange(value);
						setConfigId();
					}}

					checkoutIssues={checkoutIssues}
					
					scrolling={scrolling}
				/>,
			},
			{
				title: 'Materials',
				icon: 'materials',
				content: <Materials
					metalGroups={metalGroups}
					onMetalGroupChange={(value)=>{
						onMetalGroupChange(value);
						setConfigId();
					}}
					currentMenuMetalGroup={currentMenuMetalGroup}
					onCurrentMenuMetalGroupChange={(value)=>{
						onMenuMetalGroupChange(value);
						setConfigId();
					}}
					limitedMaterials={limitedMaterials}
					assetURI={assetURI}
				/>,
			},
			{
				title: 'Stones',
				icon: 'stones',
				content: <Stones
					stoneCut={stoneCut}

					stoneCount={stoneCount}
					stoneCountOptions={stoneCountOptions}
					onStoneCountChange={(value)=>{
						onStoneCountChange(value);
						setConfigId();
					}}

					stoneSize={stoneSize}
					stoneSizeOptions={stoneSizeOptions}
					onStoneSizeChange={(value)=>{
						onStoneSizeChange(value);
						setConfigId();
					}}

					stoneGroups={stoneGroups}
					onStoneGroupChange={(value)=>{
						onStoneGroupChange(value);
						setConfigId();
					}}

					currentMenuStoneGroup={currentMenuStoneGroup}
					onCurrentMenuStoneGroupChange={(value)=>{
						onMenuStoneGroupChange(value);
						setConfigId();
					}}

					scrolling={scrolling}
					assetURI={assetURI}
				/>,
			},
			{
				title: 'Engraving',
				icon: 'engraving',
				content: <Engraving
					engravingText={engravingText}
					onEngravingTextChange={(value)=>{
						onEngravingTextChange(value);
						setConfigId();
					}}

					engravingFont={engravingFont}
					engravingFontOptions={engravingFontOptions}
					onEngravingFontChange={(value)=>{
						onEngravingFontChange(value);
						setConfigId();
					}}
				/>,
			}
		];		
		
        return <MenuWrapper>
			<FooterContainer isOpen={this.state.isOpen} isSimple={this.props.menuType == 'simple'}>
				{
					mobile && this.props.menuType == 'simple' && <FooterOpenBtn onClick={()=>{this.setState({isOpen:!this.state.isOpen})}}>
						{this.state.isOpen ? <DownOutlined/> : <UpOutlined/>}
					</FooterOpenBtn>
				}
				<PriceWrapper>
					{this.props.menuProps.price != 0 && <TotalPrice>${this.props.menuProps.price.toLocaleString('en-US')}</TotalPrice>}
					{
						mobile && <FooterDetail>
							<FooterDetailText fontSize='14px'>Design: {ringSKU}</FooterDetailText>
							<FooterDetailText>Reference ID: {configID}</FooterDetailText>
						</FooterDetail>		
					}
					<ButtonWithBackground onClick={()=>{	
						this.props.menuProps.onCheckout();
					}}><span className='text'>Continue</span> {!mobile && <ArrowRightOutlined/>}{mobile && <RightOutlined/>}</ButtonWithBackground>
				</PriceWrapper>	
				{
					!mobile && <FooterDetail>
						<FooterDetailText fontSize='14px'>Design: {ringSKU}</FooterDetailText>
						<FooterDetailText>Reference ID: {configID}</FooterDetailText>
					</FooterDetail>		
				}					
			</FooterContainer>
			<MenuContainer isOpen={this.state.isOpen} isSimple={this.props.menuType == 'simple'}>         
				{/* {currentMenuTab >= 0 && tabs[currentMenuTab].content} */}				
				{
					tabs.map((tab,index)=><div key={index}>
						{tab.content}
					</div>)
				}
			</MenuContainer>			
		</MenuWrapper>
    }
}